export const PROP          = "HFN_TOAST_SET_PROPS"    ;
export const MERGE         = "HFN_TOAST_MERGE_PROPS"  ;
export const CLEAR         = "HFN_TOAST_CLEAR_PROPS"  ;
export const REF           = "HFN_TOAST_SETREF"       ;
